"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const lodash_clonedeep_1 = __importDefault(require("lodash.clonedeep"));
const FilterPulldown = (props) => {
    const [value, setValue] = (0, react_1.useState)(props.filter.value);
    const [active, setActive] = (0, react_1.useState)(Boolean(props.filter.active));
    const changeActive = (newStatus) => {
        setActive(newStatus);
        props.changeActive(newStatus);
    };
    const resetFilter = () => {
        if (active) {
            changeValue(undefined);
        }
    };
    const handleResetClick = (ev) => {
        ev.preventDefault();
        resetFilter();
    };
    const changeValue = (val) => {
        let newValue;
        if (props.type === "multichoice") {
            if (!val)
                newValue = undefined;
            else if (!value)
                newValue = [val];
            else {
                const nextValue = [];
                value.map((sel) => {
                    if (sel !== val)
                        nextValue.push(sel);
                    else
                        val = undefined;
                    return null;
                });
                if (val)
                    nextValue.push(val);
                newValue = nextValue;
            }
            setValue(newValue);
        }
        else {
            val = value && value.indexOf(val) > -1 ? undefined : val;
            newValue = [val];
            setValue(newValue);
        }
        changeActive(Boolean(newValue && newValue.length > 0));
        props.changeFilter("pulldown", Object.assign(Object.assign({}, (0, lodash_clonedeep_1.default)(props.filter)), { value: newValue, expanded: props.type === "multichoice" ? props.filter.expanded : false }));
    };
    (0, react_1.useEffect)(() => {
        if (!props.filter.active && active) {
            resetFilter();
        }
    }, [props.filter]);
    return ((0, jsx_runtime_1.jsxs)(react_1.Fragment, { children: [(0, jsx_runtime_1.jsx)("div", { className: "m-filter-pulldown", children: (0, jsx_runtime_1.jsx)("ul", { children: props.filter.data.map((el, i) => {
                        return ((0, jsx_runtime_1.jsxs)("li", { children: [props.type === "multichoice" && ((0, jsx_runtime_1.jsx)("div", { className: value && value.indexOf(String(el)) > -1 ? "checkbox selected" : "checkbox", onClick: (ev) => {
                                        ev.preventDefault();
                                        changeValue(String(el));
                                    }, children: value && value.indexOf(String(el)) > -1 && ((0, jsx_runtime_1.jsx)("svg", { viewBox: "0 0 12 12", width: "12", height: "12", xmlns: "http://www.w3.org/2000/svg", children: (0, jsx_runtime_1.jsx)("circle", { cx: "6", cy: "6", r: "6" }) })) })), (0, jsx_runtime_1.jsx)("a", { className: value && value.indexOf(String(el)) > -1 ? "selected" : "", href: "#", onClick: (ev) => {
                                        ev.preventDefault();
                                        changeValue(String(el));
                                    }, children: el })] }, i));
                    }) }) }), (0, jsx_runtime_1.jsxs)("div", { className: "buttons", children: [(0, jsx_runtime_1.jsx)("div", { children: (0, jsx_runtime_1.jsx)("a", { href: "#", onClick: (ev) => {
                                handleResetClick(ev);
                            }, children: "Nullstill" }) }), (0, jsx_runtime_1.jsx)("div", { children: (0, jsx_runtime_1.jsx)("a", { href: "#", onClick: (ev) => {
                                ev.preventDefault();
                                props.changeFilter("expand", Object.assign(Object.assign({}, props.filter), { expanded: !props.filter.expanded }));
                            }, children: "Lukk" }) })] })] }));
};
exports.default = FilterPulldown;
